import { FEATURE_KEYS, MODULE_KEYS, OPERATION_IDS } from '../routes/ids.js';
const tk = (value) => value;
const fieldId = (value) => value;
function outputField(name, fieldType = 'text', overrides = {}) {
    return {
        id: fieldId(`field.maintenanceDelegation.${name}`),
        name,
        labelKey: tk(`maintenanceDelegations.fields.${name}`),
        fieldType,
        layout: { md: 6 },
        value: {
            hiddenValuePolicy: 'unregister',
            submitBehavior: 'exclude',
            outputOnly: true,
        },
        display: { readonlySubmission: 'exclude' },
        ...overrides,
    };
}
const fields = [
    outputField('supportUserIdentityId'),
    outputField('targetOrganizationId'),
    outputField('targetBranchId'),
    outputField('targetClientAccountId'),
    outputField('targetPortfolioAccountId'),
    outputField('purpose'),
    outputField('ticketReference'),
    outputField('justification', 'textarea', { layout: { md: 12 } }),
    outputField('capabilities', 'multiselect', { layout: { md: 12 } }),
    outputField('allowedOperationIds', 'multiselect', { layout: { md: 12 } }),
    outputField('resourceIds', 'multiselect', { layout: { md: 12 } }),
    outputField('requiredAal'),
    outputField('policyVersion'),
    outputField('status'),
    outputField('effectiveFrom', 'datetime'),
    outputField('expiresAt', 'datetime'),
    outputField('sessionStartedAt', 'datetime'),
    outputField('sessionEndedAt', 'datetime'),
];
export const MAINTENANCE_DELEGATION_VIEW_FORM = {
    id: 'form.admin.platformSupportDelegation.view',
    schemaVersion: 1,
    module: MODULE_KEYS.ADMIN,
    feature: FEATURE_KEYS.ADMIN_MAINTENANCE_DELEGATIONS,
    telemetryId: 'experience.form.platformSupportDelegation.view',
    accessibilityLabelKey: tk('a11y.form.platformSupportDelegation.view'),
    privacyClassification: 'INTERNAL',
    availability: 'READ_ONLY',
    owner: 'platform-security',
    titleKey: tk('maintenanceDelegations.viewTitle'),
    descriptionKey: tk('maintenanceDelegations.viewDescription'),
    mode: 'view',
    operationId: OPERATION_IDS.PLATFORM_SUPPORT_DELEGATIONS_READ,
    fields,
    actions: [],
    submission: {
        includeFields: [],
        excludeFields: fields.map((field) => field.id),
    },
};
